import { render, staticRenderFns } from "./ProductMenu.vue?vue&type=template&id=c370dd34&"
import script from "./ProductMenu.vue?vue&type=script&lang=ts&"
export * from "./ProductMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports